import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import '../InnerRefresh.css';

const PrivacyPolicyPage = () => {
  const { t, language } = useLanguage();
  const sections = [
    { id: 'overview', title: 'overviewTitle', paragraphs: ['overviewText1', 'overviewText2'] },
    { id: 'cookies', title: 'cookieTitle', paragraphs: ['cookieText1', 'cookieText2'] },
    { id: 'information', title: 'infoTitle', paragraphs: ['infoText1', 'infoText2'] },
    { id: 'management', title: 'managedTitle', paragraphs: ['managedText'], list: ['managed1', 'managed2'] },
    { id: 'purposes', title: 'usedTitle', paragraphs: ['usedText'], list: ['used1', 'used2', 'used3'] }
  ];
  return (
    <div className="tb-inner" data-testid="privacy-page"><Header /><main>
      <section className="tb-inner-hero tb-container tb-inner-hero-compact"><div><h1>{t('privacyPage.title')}</h1><p className="tb-inner-lead">{t('privacyPage.subtitle')}</p></div></section>
      <div className="tb-container tb-inner-body tb-inner-document-grid">
        <nav className="tb-inner-toc tb-document-toc" aria-label={language === 'pl' ? 'Spis treści' : 'Contents'}>{sections.map(section => <a key={section.id} href={`#${section.id}`}>{t(`privacyPage.${section.title}`)}<ArrowUpRight size={15} aria-hidden="true" /></a>)}</nav>
        <article className="tb-inner-prose tb-document-prose">
          <div className="tb-privacy-intro">{[1, 2, 3, 4, 5, 6].map(i => <p key={i}>{t(`privacyPage.intro${i}`)}</p>)}</div>
          {sections.map(section => <section className="tb-inner-section" id={section.id} key={section.id}><h2>{t(`privacyPage.${section.title}`)}</h2>{section.paragraphs.map(key => <p key={key}>{t(`privacyPage.${key}`)}</p>)}{section.list && <ul>{section.list.map(key => <li key={key}>{t(`privacyPage.${key}`)}</li>)}</ul>}</section>)}
          <div className="tb-privacy-notice"><p>{t('privacyPage.gaNotice1')}</p><p>{t('privacyPage.gaNotice2')}</p></div>
          <p className="tb-privacy-contact">{t('privacyPage.contactText')} <a href="mailto:info@trustback.eu">info@trustback.eu</a></p>
        </article>
      </div>
    </main><Footer /></div>
  );
};
export default PrivacyPolicyPage;
